var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.5C4.45312 0.5 0 4.99219 0 10.5C0 16.0469 4.45312 20.5 10 20.5C15.5078 20.5 20 16.0469 20 10.5C20 4.99219 15.5078 0.5 10 0.5ZM10 18.625C5.50781 18.625 1.875 14.9922 1.875 10.5C1.875 6.04688 5.50781 2.375 10 2.375C14.4531 2.375 18.125 6.04688 18.125 10.5C18.125 14.9922 14.4531 18.625 10 18.625ZM11.5625 13.625H10.9375V10.1875C10.9375 9.67969 10.5078 9.25 10 9.25H8.75C8.20312 9.25 7.8125 9.67969 7.8125 10.1875C7.8125 10.7344 8.20312 11.125 8.75 11.125H9.0625V13.625H8.4375C7.89062 13.625 7.5 14.0547 7.5 14.5625C7.5 15.1094 7.89062 15.5 8.4375 15.5H11.5625C12.0703 15.5 12.5 15.1094 12.5 14.5625C12.5 14.0547 12.0703 13.625 11.5625 13.625ZM10 8C10.6641 8 11.25 7.45312 11.25 6.75C11.25 6.08594 10.6641 5.5 10 5.5C9.29688 5.5 8.75 6.08594 8.75 6.75C8.75 7.45312 9.29688 8 10 8Z",
    fill: "#4E535F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.1d2714fcfd56275eacd2b38b9c730a4e.svg";
export { ForwardRef as ReactComponent };